import { useMutation } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { toastUtil } from "@/utils/toastUtil";

/**
 * Reinicia la cuenta de demo y la abre en el onboarding, con o sin los documentos
 * de demo. Recarga dura: se borraron líneas y seguimiento, así que no queda caché que sirva.
 */
export function useResetOnboarding() {
  return useMutation({
    mutationFn: (withDemoDocuments: boolean) =>
      fetchToBackend("/onboarding/reset", {
        method: "POST",
        body: JSON.stringify({ withDemoDocuments }),
      }),
    onSuccess: () => {
      window.location.href = "/onboarding";
    },
    onError: () => toastUtil("No pudimos reiniciar la cuenta.", "error"),
  });
}
